import request from '@/tools/request'
import { HTTP } from './http'

export const IMPORT_FILE = (params: {
  fileId: string
  contractId: string
  resubmit?: boolean
  // contractStatus: string
}) =>
  request.POST(
    `${HTTP}/frontLandingMerchantContract/importFile`,
    params,
    'application/json',
  )

export const DELETE_CONTRACT_FILE = (params: {
  id: string // 文件id
}) =>
  request.POST(
    `${HTTP}/frontLandingMerchantContract/deleteContract`,
    params,
    'application/json',
  )
import request from '@/tools/request'
import { HTTP } from './http'

export const IMPORT_FILE = (params: {
  fileId: string
  contractId: string
  resubmit?: boolean
  // contractStatus: string
}) =>
  request.POST(
    `${HTTP}/frontLandingMerchantContract/importFile`,
    params,
    'application/json',
  )

export const DELETE_CONTRACT_FILE = (params: {
  id: string // 文件id
}) =>
  request.POST(
    `${HTTP}/frontLandingMerchantContract/deleteContract`,
    params,
    'application/json',
  )
